const authorizedEdit = [
  'activities',
  'termination_by_company',
  'termination_reason_by_company',
  'confirm_claims',
  'straw_rubber_activity',
  'industrial_activity',
  'religious_pol',
  'litigation_responsibility',
  'max_claims',
  'no_claims',
  'close_help',
  'annual_budget',
  'is_a_palace',
  'mall',
  'monument',
  'closed_more_60_days',
  'political_activity',
  'embassy_bowling_disco',
  'property_in_renovation_over_4_months',
  'property_in_historic_building',
  'is_property_occupied_or_will_be_within_2_months',
  'property_previously_insured',
  'max_fleet_size',
  'vehicle_value_range',
  'entrusted_vehicles',
  'glass_breakage_guarantee',
  'hail_guaranteeikdf',
  'have_you_owned_property_for_more_than_2_months',
  'legal_protection_option',
  'information_statements_submission_date',
  'industry_less_10m',
  'mobility_guarantee',
  'rc_pro_guarantee',
  'altitude_location',
  'market_value',
  'business_loss_guarantee',
  'renovation',
  'had_waived_certain_remedies_in_its_lease',
  'disaffected',
  'zone_ind_com_art',
  'metropolitan_france',
  'built_covered_hard_materials',
  'take_care_building',
  'extinguisher_conformed',
  'guarantee_limit',
  'civil_responsibility_asso',
  'deductible_amount',
  'employees_number',
  'representatives_number',
  'total_members',
  'yearly_events',
  'participants_per_event',
  'turnover',
  'local',
  'company_in_creation',
  'extended_legal_protection',
  'exploitation_responsibility',
  'surface_area',
  'social_mandate_responsibility',
  'extended_legal_protection_mrp',
  'archives_capital',
  'value_capital',
  'art_capital',
  'theft_capital',
  'owner_insurance',
  'exploitation_loss',
  'lent_goods',
  'rc_pro',
  'tech_catastrophe',
  'fire_explosion_attack_climatic_event',
  'attack',
  'catastrophe',
  'theft_vandalism',
  'light_inflatable_structure',
  'water_damage',
  'broken_windows',
  'broken_machine',
  'external_furniture',
  'chilled_merchandise',
  'electric_damage',
  'tenant_responsibility',
  'neighbours_appeal',
  'tenant_appeal',
  'lawsuit_defense',
  'extended_legal_protection',
  'assistance',
  'cat_nat_risk',
  'subscriber_type',
  'building_category',
  'building_type',
  'main_use',
  'building_condition',
  'total_buildings',
  'risk_typology',
  'concrete_floor',
  'empty_unoccupied_works',
  'broker_fee',
  'paperwork_fee',
  'commission_fee',
  'contribution_adjustment',
  'machine_breakdown',
  'indoor_pool',
  'outdoor_pool',
  'solar_panels',
  'veranda',
  'empty_reason',
  'deductible_cost_index',
  'guarantee_type',
  'furniture_capital',
  'construction_year',
  'acquisition_date',
  'is_continuously_insured_since_acquisition',
  'legal_entity_name',
  'last_contract_number',
  'last_company_name',
  'last_termination_date',
  'furniture_capital_other',
  'buildings',
  'occupation_trade',
  'risk_been_insured',
  'siret',
  'rna',
  'company_been_insured',
  'sites',
  'claims',
  'resident_status',
  'surface_area_sites',
  'classic_accident_insurance',
  'reinforced_accident_insurance',
  'blocked_activities',
  'embassy_bowling_disco_wk',
  '75percent_tough_materials',
  '2_incidents_max',
  'more_500m_altitude',
  'castle',
  'liquidation',
  'ffb_1000_times',
  'wood_plastic_nuclear_activity',
  'straw_rubber_stock',
  'walking_cooler_wk',
  'electric_conformed',
  'restaurant_activity',
  'chilled_products_conformed',
  'renovation_wk',
  '28m_high_wk',
  'combustible_packaging',
  'wholesale_business',
  'france_with_corsica',
  'industrial_straw_activity',
  'construction_activity',
  'medical_activity',
  'legal_activity',
  'has_already_been_terminated_by_asx',
  'localized_qpv',
  'lci_sufficient',
  'half_timbering_structure',
  'close_before_2300',
  'monument_outside_prerequisites',
  'religious_pol',
  'building_been_insured',
  'built_covered_hard_materials',
  'good_state',
  'accessibility',
  'activity_open_public',
  'contractual_general_indemnity_limit',
  'castle_manor',
  'wood_full_risk_prerequisite',
  'classified_listed',
  'redress_liquidation',
  'wooden_construction',
  'temporary_activity',
  'specific1_activities',
  'religious_political_union',
  'close_industrial_complex',
  'specific2_activities',
  'built_covered_hard_materials',
  'specific3_activities',
  'waiver_recourse_against_tenants',
  'cold_rooms_flammable_liquids',
  'land_classified_non_constructible',
  'building_height',
  'agricultural_building',
  'hard_materials',
  'walking_cooler',
  '28m_high',
  'sea_side',
  'blocked_activities',

  //  MRIWK
  'building_quality',
  'is_condominium',
  'is_vacant',
  'vacant_reason',
  'vacant_area',
  'contains_professional_activity',
  'office_activity_percentage',
  'shop_activity_percentage',
  'contains_outbuilding',
  'outbuilding_surface',
  'is_furnished',
  'furniture_guarantee',
  'optionnal_guarantees',
  'deductible_amount_ratio',
  'guarantee_package',
  'hard_material_prerequisite',
  'good_state_prerequisite',
  'firefighting_water_prerequisite',
  'rescue_access_prerequisite',
  'metropolitan_france_prerequisite',
  'public_late_prerequisite',
  'actually_rented_prerequisite',
  'is_asl_aful_prerequisite',
  'fast_food_prerequisite',
  'classified_prerequisite',
  'monument_prerequisite',
  'is_in_liquidation_or_receivership',
  'liquidation_prerequisite',
  'wood_construction_prerequisite',
  'temporary_activity_prerequisite',
  'recreation_activity_prerequisite',
  'political_activity_prerequisite',
  'near_industrial_activity_prerequisite',
  'industrial_activity_prerequisite',
  'transformed_products_prerequisite',
  'waiver_clause_prerequisite',
  'cold_room_prerequisite',
  'unbuildable_prerequisite',
  'tall_building_prerequisite',
  'roof_prerequisite',
  'tags_roof_materials',
  'risk_has_graffitis_or_tags',
  'roof_non_standard_materials',
  'roof_built_or_replaced_after_2018',
  'roof_is_flat_or_terrace',
  'key_man_guarantee',
  'is_property_dealer',
  'property_in_castle_or_listed_building',
  'risk_has_prohibited_restaurant_activities',
  'risk_has_industrial_activities',
  'religious_political',
  '90percent_tough_materials',
  'agricultural_building_prerequisite',
  'igh_igs_prerequisite',
  'wood_floor_prerequisite',
  'peril_prerequisite',
  'vacant_prequisite',
  'demolition_prerequisite',
  'zup_prerequisite',
  'flooding_prerequisite',
  'condominium_surface_prerequisite',

  //  RCPHX`
  'activity_type',
  'activity_detail',
  'turnover',
  'turnover_usa_canada',
  'turnover_usa_canada_amount',
  'guarantee_limit',
  'legal_protection_rcphx',
  'legal_protection_rcphx_extended',
  'exploitation_responsibility',
  'payment_type',
  'broker_fee',
  'contribution_adjustment',
  'paperwork_fee',
  'paperwork_fee_payment',
  'geographic_exposure_hiscox',
  'geographic_exposure_hiscox_world',
  'insurance_historic_hiscox',
  'activity_hiscox_tech',
  'activity_hiscox_tech_world',
  'activity_hiscox_mac',
  'activity_hiscox_mac_world',
  'activity_hiscox_man',
  'activity_hiscox_man_world',
  'activity_hiscox_med',
  'activity_hiscox_med_world',
  'activity_hiscox_misc',
  'activity_transport_misc',
  'activity_borloo_misc',
  'activity_hiscox_misc_tattoo',
  'activity_hiscox_tag',
  'activity_hiscox_tag_world',
  'activity_hiscox_secu',
  'compliance_hiscox_misc_tattoo',
  'activity_hiscox_tech_ia',
  'activity_hiscox_bie',
  'activity_hiscox_bie_pregnants',
  'activity_hiscox_bie_pregnants_manipulation',
  'activity_hiscox_bie_children',
  'activity_hiscox_med_paramedical',
  'activity_hiscox_osteo',
  'cyber_option_rcphx',
  'cyber_option_rcphx_extended',
  'cyber_option_rcphx_fraud',
  'activity_hiscox_cyber',
  'history_cyber_hiscox',
  'geographic_exposure_hiscox_cyber',
  'history_risk_hiscox',
  'legal_protection_usa_canada',

  // RCNGAWK
  'withdrawal_drivin_license',
  'liquidation_property_or_legal_recovery',
  'guaranteed_liability_involved',
  'more_than_two_claims',
  'compliant_installations',
  'bodily_claim',
  'driving_while_intoxicated',
  'political_person_exposed',
  'w_garage_certificate_number',
  'w_garage_certificate',

  // MRIML
  'risk_assured_location_outside_metropolitan_france',
  'activity_in_qpv_area',
  'risk_under_construction_or_90_percent_materials',
  'risk_is_for_depollution_rehabilitation',
  'fire_claim_last_60_months_subscriber_affiliates',
  'risk_includes_veranda_over_3m2',
  'risk_is_wooden_structure_or_wood_cladding',
  'risk_is_contiguous_with_industrial_activity',
  'proximity_of_building_to_risk_of_peril_in_marseille',
  'risk_is_occupied_illegally',
  'risk_is_subject_to_alignment',
  'risk_contains_inflammable_liquids',
  'risk_is_above_1500m_and_inaccessible_by_rescue',
  'presence_of_lease_with_waiver_of_recourse_clause',
  'building_subject_to_major_works_or_renovation',
  'risk_dedicated_to_demolition',
  'establishments_receiving_public_category_1_to_4',
  'establishments_receiving_public_category_5_closing_before_23h',
  'risk_involves_specific_high_risk_activities',
  'risk_contains_asbestos_or_specific_roofing_materials',
  'risk_under_judicial_administration',
  'policyholder_in_bankruptcy_or_liquidation',
  'risk_is_vacant_land',
  'risk_declared_contains_high_risk_activities_or_premises',
  'risk_contains_religious_political_diplomatic_or_union_activity',
  'risk_declared_is_high_rise_or_large_real_estate_complex',
  'is_lci_of_x_million_sufficient',
  'risk_declared_is_a_castle',
  'risk_declared_is_classified_or_listed_building',
  'risk_is_an_unbuildable_land',
  'risk_contains_cold_storage_above_120m3',
  'risk_declared_is_in_flood_zone',
  'risk_is_not_in_good_condition',
  'will_property_be_renovated_in_4_months',
  'will_property_be_renovated_in_more_than_4_months',
  'risk_declared_under_unsanitary_or_dangerous_decree',
  'outdoor_indoor_pool',
  'renewable_energies',
  'specific_risk',

  // PNOML
  'no_prohibited_activities_declared',
  'property_under_construction_prerequisite',
  'tenant_in_restructuring_or_liquidation',
  'property_under_construction',
  'under_construction_duration',
  'squat_option',
  'furnished_rental',

  // RCGLS
  'no_activity_usa_canada',
  'not_listed_in_eu_sanctions',
  'accurate_and_truthful_declarations',
  'report_change_of_situation',
  'no_acpr_sanctions',
  'no_foreign_branch_or_subsidiary',
  'no_problems_last_5_years',
  'no_known_risk_facts',
  'orias_required_for_guarantee',
  'registration_required_for_guarantee',
  'already_resiliated_by_assurmax',
  'politically_exposed_person',
  'legal_and_regulatory_compliance',
  // ACI prerequisites
  'multiple_principals',
  'registered_commercial_agent',
  'professional_card_number',
  'in_process_cci',
  'issuing_chamber',
  'agency_contact_details',
  // CGP_CIF prerequisites
  'no_financial_engineering',
  'real_estate_tax_reduction_activity',
  'no_asset_management_for_third_parties',
  'no_miscellaneous_goods_intermediation',
  'no_gestion_patrimoine_without_cif',
  // IO BSP prerequisites
  'mandataires_to_cover',
  'orias_compliance_insurance',
  'accessory_activity_ia_mia_dfb',
  'accessory_activity_ia_mia',
  'accessory_activity_dfb',

  // COA
  'delegation_or_mandate',
  'wants_financial_guarantee',
  'financial_guarantee_amount',
  'accounts_verified_by_accountant',
  'mandataires_to_cover_mias',
  'no_risky_insurance_contexts',
  'reinsurance_broker',
  'orias_compliance_assurance',
  'accessory_activity_iobsp_dfb_cif',
  'accessory_activity_iobsp',
  'accessory_activity_cif',

  // AI
  'no_foreign_branch',
  'legal_representative_name',
  'no_property_management_activity',
  'real_estate_tax_reduction_activity_ai',
  'wants_financial_guarantee_no_funds',
  'financial_guarantee_amount_no_funds',
  'accessory_activity_ia_mia_or_iobsp_miobsp',
  'accessory_activity_ia_mia_alt',
  'accessory_activity_iobsp_miobsp',

  // MIA
  'single_mandate_insurance',
  'single_mandate_iobsp',
  'mandant_details',
  'orias_compliance_miobsp',
  'orias_number',
  'orias_compliance_bank',
  'risky_mandant_relationships',
  'maritime_insurance',
  'maritime_percentage',
  'construction_insurance',
  'construction_insurance_company_check',
  'construction_project_check',
  'construction_revenue_percentage',
  'only_france_based_clients',
  'no_us_canada_bank_activity',

  'accounts_verified_by_accountant_mia',

  // OPTIONS
  'iobsp_broker_errors',
  'iobsp_exclusive_agent_errors',
  'iobsp_non_exclusive_agent_errors',
  'iobsp_mandate_professional',
  'insurance_intermediary_guarantee',
  'general_agents_and_brokers_errors',
  'insurance_sub_agents_errors',
  'real_estate_transaction_guarantee',
  'investment_advisor_errors',
  'iobsp_broker_guarantee'
];

export default authorizedEdit;
